import React from 'react';
import { STATUS_META } from './styles';
import { StatusEditor } from './StatusEditor';

const fmt = (d) => {
  if (!d) return null;
  const dt = new Date(`${String(d).slice(0, 10)}T00:00:00`);
  return Number.isNaN(dt.getTime()) ? d : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const SourceCard = ({ source, selected, onToggle, editing, onEdit, onSave, busy, choices, index }) => {
  const m = STATUS_META[source.source_status];
  const tp = `source-${source.id}`;
  return (
    <div className={`ss-card ${selected ? 'sel' : ''}`} style={{ animationDelay: `${Math.min(index, 20) * 18}ms` }}
      data-testid={`${tp}-card`}>
      <div className="ss-row">
        <input type="checkbox" className="ss-check" checked={selected} onChange={onToggle}
          aria-label={`Select ${source.title}`} style={{ marginTop: 3, accentColor: '#3b82f6' }}
          data-testid={`${tp}-checkbox`} />
        <div className="ss-main">
          <div className="ss-name" data-testid={`${tp}-title`}>{source.title}</div>
          <div className="ss-meta">
            <span>{source.chunk_count} passages</span>
            <span data-testid={`${tp}-effective`}>{fmt(source.effective_date) ? `Effective ${fmt(source.effective_date)}` : 'No effective date'}</span>
            {source.superseded_by_title && (
              <span data-testid={`${tp}-replaced-by`}>Replaced by <span className="ss-link">{source.superseded_by_title}</span></span>
            )}
            {source.replaces.length > 0 && <span>Replaces {source.replaces.join(', ')}</span>}
            {source.updated_by && source.source_status !== 'unverified' && <span>Set by {source.updated_by}</span>}
          </div>
        </div>
        <span className="ss-pill" style={{ '--c': m.color }} title={m.hint} data-testid={`${tp}-status`}>{m.label}</span>
        <button className="ss-ghost" onClick={onEdit} data-testid={`${tp}-edit`}>{editing ? 'Close' : 'Change'}</button>
      </div>
      {editing && (
        <StatusEditor initial={source} choices={choices} excludeIds={[source.id]} busy={busy}
          onSave={onSave} onCancel={onEdit} testPrefix={tp} />
      )}
    </div>
  );
};
